import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useGetLotSizing } from '@/services/apis/queries/lot-sizing/use-get-lot-sizing';
import { CriteriaForm } from './component/criteria-form/criteria-form';
import { useRefreshLotSizingCriteria } from './hooks/use-refresh-lot-sizing-criteria';

type LotSizingCriteriaProps = {
  lotSizingId: string;
};

export function LotSizingCriteria({ lotSizingId }: LotSizingCriteriaProps) {
  const { t } = useTranslation(['lotSizing']);
  const { data: lotSizing } = useGetLotSizing(lotSizingId);
  const { refreshCriteria, isPending } = useRefreshLotSizingCriteria({
    lotSizingId,
  });

  const hasSingleSupplier = lotSizing?.suppliers?.length === 1;

  return (
    <Card>
      <CardHeader className='flex flex-row items-center justify-between'>
        <CardTitle>{t('lotSizing:criteria')}</CardTitle>
        {hasSingleSupplier && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                disabled={isPending}
                onClick={refreshCriteria}
                size='icon'
                variant='outline'
              >
                <RefreshCw
                  className={`size-4 ${isPending ? 'animate-spin' : ''}`}
                />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              {t('lotSizing:refresh-criteria-tooltip')}
            </TooltipContent>
          </Tooltip>
        )}
      </CardHeader>
      <CardContent className='space-y-4'>
        <CriteriaForm lotSizingId={lotSizingId} />
      </CardContent>
    </Card>
  );
}
